export enum ExperienceType {
    Property = 'property',
    Activity = 'activity',
    Boat = 'boat',
    Commercial = 'commercial',
    Vehicle = 'vehicle',
}

export enum ActivityType {
    GoKarts = 'goKarts',
    Buggies = 'buggies',
    EBikes = 'eBikes',
}

export enum BoatType {
    Bass = 'bass',
    CabinCruiser = 'cabin cruiser',
    Catamaran = 'catamaran',
    Dingy = 'dingy',
    Jetboat = 'jetboat',
    Inflatable = 'inflatable',
    SailBoat = 'sailboat',
    Skiff = 'skiff',
    Superyacht = 'superyacht',
    Yacht = 'yacht',
}

export enum CommercialType {
    House = 'house',
    Office = 'office',
}

export enum PropertyType {
    Apartment = 'apartment',
    Cabin = 'cabin',
    Commercial = 'commercial',
    Duplex = 'duplex',
    House = 'house',
    OfficeSpace = 'office space',
    Unit = 'unit',
}

export enum VehicleType {
    Car = 'car',
    Motorbike = 'motorbike',
}

export enum AvailabilityMode {
    Standalone = 'standalone',
    AddOn = 'addOn',
    Both = 'standaloneAndAddOn',
}

export enum SpaceType {
    Bathroom = 'bathroom',
    Bedroom = 'bedroom',
    Boardroom = 'boardroom',
    DiningArea = 'diningArea',
    GameRoom = 'gameRoom',
    Garage = 'garage',
    Kitchen = 'kitchen',
    LivingRoom = 'livingRoom',
    PrivateOffice = 'privateOffice',
}
export enum CommercialSpaceType {
    Desk = 'desk',
    PrivateOffice = 'privateOffice',
    MeetingRoom = 'meetingRoom',
    EntireVenue = 'entireVenue',
}

export enum CleaningFeeType {
    Flat = 'flat',
    PerRoom = 'perRoom',
    Tiered = 'tiered',
    ByZone = 'byZone',
}

export enum FeeApplies {
    PerNight = 'perNight',
    PerBooking = 'perBooking',
}

export enum FeeType {
    Fixed = 'fixed',
    PerHour = 'perHour',
    PerDay = 'perDay',
    PerNight = 'perNight',
    PerHourPerGuest = 'perHourPerGuest',
    PerDayPerGuest = 'perDayPerGuest',
    PerNightPerGuest = 'perNightPerGuest',
    PerDeskPerDay = 'perDeskPerDay',
    PerDeskPerHalfDay = 'perDeskPerHalfDay',
    PerOfficePerDay = 'perOfficePerDay',
    PerOfficePerHalfDay = 'perOfficePerHalfDay',
    PerMeetingRoomPerDay = 'perMeetingRoomPerDay',
    PerMeetingRoomPerHalfDay = 'perMeetingRoomPerHalfDay',
    EntireVenuePerDay = 'entireVenuePerDay',
    EntireVenuePerHalfDay = 'entireVenuePerHalfDay',
    EntireVenuePerNight = 'entireVenuePerNight',
}
